import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';
import { Directive, forwardRef, OnInit } from '@angular/core';

import { iban } from './validator';

@Directive({
    selector: '[iban][formControlName],[iban][formControl],[iban][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => IbanValidatorDirective),
            multi: true,
        },
    ],
})
export class IbanValidatorDirective implements Validator, OnInit {
    private validator: ValidatorFn;

    ngOnInit() {
        this.validator = iban();
    }

    validate(c: AbstractControl): { [key: string]: any } {
        return this.validator(c);
    }
}
